export { default } from "./Ingredients";
export * from "./Ingredients";